import createInstance, { cleanLocalStorageCache } from "../util";
import { BusinessLineEnum } from "constants/base";
import { BaseResponse } from "../common";
import { LocalCacheKey } from "constants/cacheKeys";
import { isSuccess } from "util/Common";
import { spotAllSymbol } from "api/ct";
import { localForage } from "@saas2/utils";
import {
  MARKET_TICKER_RES_REQUEST,
  MARKET_TICKER_RES,
  SPOT_TICKER_INFO_RES,
} from "api/stragety/types/strageryEntryType";

let commonInstance2 = createInstance("/v1/mix");
let commonInstance = createInstance("/v1/trigger/strategy");
let macpInstance = createInstance("/v1/mcp");
let platFormInstance = createInstance("/v1/strategyPlatform");
let spotInstance = createInstance("/v1/spot");
let baseInstance = createInstance("/v1");

/**
 * 复制策略获取策略来源
 * @param params
 * @returns {Promise<{}>}
 */
export function getCopyStrategyInfo(params: { strategyId: number }) {
  return platFormInstance.post("/library/getCopyStrategyInfo", params);
}

/**
 * 混合合约资产及保证金模式
 * businessLine
 * tokenId
 */
export const mcpAsset = (data) => {
  return macpInstance.post("/account/token", data);
};

/**
 * 获取策略支持的交易对
 * @param params
 * @returns {Promise<unknown>}
 */
export function supportedCurrency(params: {
  businessLines: (number | string)[];
}) {
  return commonInstance.post("/config/common/supportedCurrency", params);
}

/**
 * 策略推荐AI配置
 * @param params
 * @returns {Promise<{}>}
 */
export function defaultAI(params: {
  businessLine: number;
  symbolId: string;
  gridType: number;
}) {
  return commonInstance.post("/config/defaultAI", params);
}

type PageParam = {
  pageSize: number; //每一页条数
  lastEndId: number | string; //上次查询结果最后id,分页基于这个继续向后查
  isPre: boolean; //是否是查询上一页 默认 false
};
/**
 *  当前、历史策略的挂单列表
 * @param param
 * @returns {Promise<>}
 */
export type GridOrderCurrentParam = PageParam & {
  strategyId?: string;
  startTime: string; //策略的开始时间
  endTime: string; //策略的结束时间
  businessLine: string; //业务线（1:现货/币币业务线）
  gridType: number; //网格类型
  strategyType?: string; // 1网格 2DCA
  strategyDirection?: number; // 1正向 2反向
};

/**
 * 获取当前策略列表
 * @param params
 * @returns {Promise<{}>}
 */
export function getStrategyCurrentList(params: Partial<GridOrderCurrentParam>) {
  commonInstance.setHeaderRequestTime();
  return commonInstance.post("/common/query/strategyCurrentList", params);
}

export type GridOrderHistoryParam = PageParam & {
  strategyId: string;
  startTime: number; //策略的开始时间
  endTime: number; //策略的结束时间
  businessLine: string; //业务线（1:现货/币币业务线）
  gridType?: number; //网格类型
  strategyReason: number; // 终止原因
  strategyType?: string; //策略类型
  strategyDirection: number | string;
};

/**
 * 获取历史策略列表
 * @param params
 * @returns {Promise<{}>}
 */
export function getStrategyHistoryList(
  params: Partial<GridOrderHistoryParam>
): Promise<BaseResponse<{ data: any[] }>> {
  return commonInstance.post("/common/query/strategyHistoryList", params);
}

/**
 * 混合合约币对列表
 */
export const getMcpContractList = (data: {
  businessLine?: BusinessLineEnum;
  md5Value?: string | null;
}): Promise<
  BaseResponse<{
    [x: string]: never[];
  }>
> => {
  // return macpInstance.post('/ct/list2', data)
  return macpInstance.get("ct/symbols", data);
};

/**
 * 初始化业务线配置
 * 。。。。。 这个函数没人用啊，不要再用了
 */
export const getBusinessLineConfig = async (businessLines, callback?) => {
  if (
    businessLines.some(
      (line) =>
        line === BusinessLineEnum.USDT_MIX_CONTRACT_BL ||
        line === BusinessLineEnum.USD_MIX_CONTRACT_BL
    )
  ) {
    const localMd5Key =
      LocalCacheKey.CONTRACT_LIST_MD5_KEY +
      BusinessLineEnum.USDT_MIX_CONTRACT_BL;
    const localDataKey =
      LocalCacheKey.CONTRACT_LIST_DATA + BusinessLineEnum.USDT_MIX_CONTRACT_BL;
    const oldMd5Value = await localForage.getItem<string>(localMd5Key);
    getMcpContractList({
      businessLine: BusinessLineEnum.USDT_MIX_CONTRACT_BL,
      md5Value: oldMd5Value,
    }).then(async (res: any) => {
      if (isSuccess(res?.code) && res.data) {
        let tmp = res.data?.listDTOS || [];
        const md5Value = res.data?.md5Value;
        if (md5Value && oldMd5Value !== md5Value) {
          try {
            await localForage.setItem(localDataKey, JSON.stringify(tmp));
            await localForage.setItem(localMd5Key, md5Value);
          } catch {
            await localForage.removeItem(localMd5Key);
          }
        }
        if (md5Value && oldMd5Value === md5Value && !tmp?.length) {
          try {
            tmp = JSON.parse((await localForage.getItem(localDataKey)) || "");
          } catch (error) {
            await localForage.removeItem(localDataKey);
          }
        }
        let tmp2 = [];
        tmp.forEach((item) => {
          if (item.businessLine === BusinessLineEnum.USDT_MIX_CONTRACT_BL) {
            tmp2 = tmp2.concat(item.symbolDTOList);
          }
        });
        callback?.(tmp2);
      }
    });
  } else if (businessLines.some((line) => line === BusinessLineEnum.SPOT_BL)) {
    spotAllSymbol().then((result: any) => {
      if (result.code === "00000" && result.data) {
        const spotConfigList = result.data.items[0].symbolDTOList || [];
        callback?.(spotConfigList);
      }
    });
  }
};

/**
 * 初始化业务线配置
 */
export const getBusinessLineConfigPromise = (
  businessLines,
  locale?: string
) => {
  // if (
  //   businessLines.some(
  //     (line) =>
  //       line === BusinessLineEnum.USDT_MIX_CONTRACT_BL ||
  //       line === BusinessLineEnum.USD_MIX_CONTRACT_BL
  //   )
  // ) {
  //   return getMcpContractList({
  //     businessLine: BusinessLineEnum.USDT_MIX_CONTRACT_BL,
  //   });
  // } else if (businessLines.some((line) => line === BusinessLineEnum.SPOT_BL)) {
    // 英国合规需要locale
    return spotAllSymbol({ locale });
  // }
};

/**
 * 获取策略的详情
 * @param params
 * @returns {Promise<{}>}
 */
export const getGridOne = (params: {
  businessLine: number;
  strategyId: string;
  strategyFlag?: number;
}) => {
  return commonInstance.post("/query/gridOne", params);
};

/**
 * 获取可用资产
 */
export const getMcpAccountList = (params) => {
  // { businessLine: BusinessLineEnum.USDT_MIX_CONTRACT_BL }
  return macpInstance.post("/account/list", params);
};

/**
 * 获取交易对的策略配置
 * 仅与策略相关的配置
 * @param params
 * @returns {Promise<unknown>}
 */
export function getDefaultConfig(params: {
  businessLine: number;
  symbolId: string;
  gridType?: number;
  dcaType?: number;
}) {
  return commonInstance.post("/config/defaultConfig", params);
}

// 网格策略基本参数
export type BaseGridStrategyParam = {
  businessLine: number;
  symbolId: string;
  strategyNum: number;
  strategyMaxPrice: string; // 网格最大价格
  strategyMinPrice: string; // 网格最小价格
  gridType: number; // 网格类型
  strategyModel: number; //网格挂单模式 1:等比间隔、2:等差间隔
  investTokens: { [key: string]: string }; //  策略投资情况，key是币种ID，value是投资量
  triggerPrice: string; //触发价格
};

/**
 * 策略参数估算
 * @param params
 * @returns {Promise<{}>}
 */
export function confirmParam(params: BaseGridStrategyParam): Promise<any> {
  return commonInstance.post("/confirmParam", params);
}

/**
 * 网格计算爆仓价
 * @param params
 * @returns {Promise<{}>}
 */
export function getGridReducePrice(params: BaseGridStrategyParam) {
  return commonInstance.post("/reducePrice", params);
}
/**
 * dca计算爆仓价
 * @param params
 * @returns {Promise<{}>}
 */
export function getDcaReducePrice(params: BaseGridStrategyParam) {
  return commonInstance.post("/dca/reducePrice", params);
}

/**
 * 创建策略
 * @param params
 * @returns {Promise<{}>}
 */
export function placeStrategyGrid(
  params: BaseGridStrategyParam & {
    tokenId: string; //  合约策略使用：保证集币种。币币策略不需要
    strategyModel: number; //网格挂单模式 1:等比间隔、2:等差间隔
    strategyAttribute: string; //策略属性选择：1:AI策略、2:手动创建、
    strategyModelGrade: number; // 开单限价
    stopProfitPrice: string; //止盈价格
    stopLossPrice: string; //止损价格
    endOperate: number; // 终止时操作，币币策略，合约策略，都有
    marginMode: number; //保证金模式 合约策略专用
    leverage: number; //杠杆 合约策略专用
    srcId?: string; // 策略平台 复制购买策略关联参数
  }
) {
  return commonInstance.post("/placeStrategyGrid", params);
}

/**
 * 终止策略确认
 * @param params
 * @returns {Promise<{}>}
 */
export function cancelStrategyConfirm(params: {
  businessLine: number;
  strategyId: string;
  endOperate?: any;
  gridType?: string;
}) {
  return commonInstance.post("/common/cancelStrategyConfirm", params);
}

/**
 * 终止策略
 * @param params
 * @returns {Promise<{}>}
 */
export function cancelStrategy(params: {
  businessLine?: number;
  strategyId: string;
  endOperate?: number; // 终止时操作，1.手动操作 2.全平 3.全撤
  gridType?: number | string;
}) {
  return commonInstance.post("/common/cancelStrategy", params);
}

/**
 * 策略详情
 */
export const getStrategyDetail = (params: {
  businessLine: number;
  strategyId: number | string;
  strategyFlag?: number | boolean;
}) => {
  return commonInstance.post<BaseResponse<any>>(
    "/common/query/strategyDetail",
    {
      strategyFlag: false,
      ...params,
    }
  );
};
/**
 * 策略详情-收藏
 */
export const getStrategCollectionDetail = (params: {
  businessLine: number;
  strategyId: number | string;
  strategyFlag?: number | boolean;
}) => {
  return commonInstance.post<BaseResponse<any>>("/collect/detail", {
    strategyFlag: false,
    ...params,
  });
};

/**
 * 获取订单策略接口
 * https://yapi.cointr.me/project/44/interface/api/10093
 */
export const getStrategyList = (params: GridOrderCurrentParam) => {
  return commonInstance.post("/query/strategyOrderList", params);
};

//分享的链接
export const getShareLinkUrl = (data) => {
  return commonInstance2.post("/public/getShareContent", data);
};

//获取分享的内容
export const getShareContent = (data) => {
  return commonInstance2.post("/public/getShareContent", data);
};

/**
 * 更新网格策略
 * @param params
 * @returns {Promise<{}>}
 */
export function updateStrategyGrid(params: {
  businessLine: number;
  strategyId: string;
  stopProfitPrice?: string; //止盈价格
  stopLossPrice?: string; //止损价格
  endOperate?: number; // 终止时操作，币币策略，合约策略，都有
  leverage?: number; //杠杆 合约策略专用
  triggerParams?: any;
}) {
  return commonInstance.post("/updateStrategyGrid", params);
}

/**
 * 更新dca策略
 * @param params
 * @returns {Promise<{}>}
 */

export function updateStrategyDCA(params: {
  businessLine: number;
  strategyId: string;
  stopProfitPrice?: string; //止盈价格
  stopLossPrice?: string; //止损价格
  endOperate?: number; // 终止时操作，币币策略，合约策略，都有
  leverage?: number; //杠杆 合约策略专用
}) {
  return commonInstance.post("/dca/updateStrategy", params);
}

export function getAllCommonCategory(params = { strategyType: 1 }) {
  return commonInstance.post("/config/v2/common/currencyList", params);
}

/**
 * https://yapi.sniper5.vip/project/44/interface/api/41265
 * @param params
 * @returns
 */
export function getAllCommonCategoryNew(
  params = { md5Value: 1, languageType: 0 }
) {
  // /v1/trigger/strategy/config/common/allCategory
  return baseInstance.post(`/trigger/strategy/config/common/allSampleCategoryV2`, {
    strategyType: 1,
  });
  // return spotInstance.get(
  //   `/symbol/getAllPartitionV2?languageType=${params.languageType}&showWatchGroup=true&md5Value=${params.md5Value}`
  // );
  // return commonInstance.post('/config/common/allSampleCategory', params)
}

export function getAllSymbol(params = { businessLines: [10] }) {
  return commonInstance.post("/config/common/currencyList", params);
}

/**
 * 检查是否有可发布策略
 * https://yapi.sniper5.vip/project/53/interface/api/33796
 */
export const checkPublishStrategy = (params: {
  strategyType: number | string;
  strategyBaseType: number;
}) => {
  return platFormInstance.post("/owner/checkIsPublishStrategy", params);
};

/**
 * 当前用户身份
 * strategy-trading/my-strategy
 */
export const strategyUser = () => {
  return platFormInstance.post("/square/strategyStatistics");
};

/**
 * 获取网格"已完成"数据
 * @param params
 * @returns {Promise<unknown>}
 */
export function trackingListHistory(
  params: {
    startTime?: string;
    endTime?: string;
    strategyId: string;
    businessLine: number;
  },
  instance?: typeof commonInstance
) {
  const getRequestInstance = instance || commonInstance;
  return getRequestInstance.post("/query/trackingListHistory", params);
}

/**
 * 策略首页币对列表
 */

export const SymbolStrategyList = (params: { businessLine: number }) => {
  return commonInstance.post("/public/selectSymbolStrategyCount", params);
};
/**
 * 策略首页币对列表
 */
export const GetHomeQuotation = (params: { businessLine: number }) =>
  commonInstance2.get("/market/getHomeQuotation", params);

/**
 * 波动率
 * https://yapi.sniper5.vip/project/53/interface/api/39928
 */
export const getVolatilityList = (params: {
  volatilityType: number;
  businessLine: number;
}) => {
  return platFormInstance.post("/public/volatility/list", params);
};

/**
 * 收藏策略
 * https://yapi.sniper5.vip/project/44/interface/api/35518
 */

export const collectStrategy = (strategyId: string) => {
  return commonInstance.post("/collect/add", { strategyId: strategyId });
};

/**
 * 查询收藏列表
 * https://yapi.sniper5.vip/project/44/interface/api/35532
 */
export const getCollectStrategyList = (params: {
  strategyId: string;
  strategyType: string;
}) => {
  return commonInstance.post("/collect/list", params);
};

/**
 * 取消收藏
 * https://yapi.sniper5.vip/project/44/interface/api/35525
 */
export const cancelCollectStrategyList = (strategyId: string) => {
  return commonInstance.post("/collect/cancel", { strategyId: strategyId });
};

/**
 * 子账户修改保证金
 * https://yapi.sniper5.vip/project/44/interface/api/41566
 */
interface transferProps {
  strategyId: string;
  amount: number | string;
  transferType: number; //1.转入子账户  0.转出子账户
  coinName: string;
  bizType: number; // 1是保证金 2是利润
  openPosition?: string; //tv 是否参与开仓是否开仓 0 不参与开仓  1参与开仓
}
export const subAccountTransfer = (params: transferProps) => {
  return commonInstance.post<BaseResponse<any>>("/subAccount/transfer", params);
};
/**
 * 子账户爆仓价计算
 * https://yapi.sniper5.vip/project/44/interface/api/41566
 */
export const subAccountReducePrice = (params) => {
  return commonInstance.post("/subAccount/reducePrice", params);
};
/**
 * 子账户可用计算
 * https://yapi.sniper5.vip/project/44/interface/api/41566
 */
interface balanceProps {
  strategyId: string;
  bizType: number; // 查询类型： 1 保证金 2 利润
  coinName?: string; //反向传币
}
export const subAccountBalance = (params: balanceProps) => {
  return commonInstance.post<
    BaseResponse<{
      tokenId: string;
      maxTransferOut: string;
      available: string;
      hisExtract: string;
    }>
  >("/subAccount/balance", params);
};

/**
 * tv提取利润新增配置接口，获取最小可提
 * https://yapi.sniper5.vip/project/44/interface/api/91749
 */
export const getStrategyConf = () => {
  return commonInstance.post<
    BaseResponse<{
      minTransferInLimit: string;
      minTransferOutLimit: string;
    }>
  >("/public/conf/strategyConf");
};

/**
 * 囤币宝利润提取详情
 * https://yapi.sniper5.vip/project/44/interface/api/84477
 */
interface extractDetailProps {
  strategyId: string;
}

interface extractDetailResponse {
  curExtract: string;
  minExtract: string;
  hisExtract: string;
  token: string;
}

export const getHoardExtractDetail = (params: extractDetailProps) => {
  return commonInstance.post<BaseResponse<extractDetailResponse>>(
    "/portfolio/extractDetail",
    params
  );
};
/*
 * 囤币宝提取利润
 * https://yapi.sniper5.vip/project/44/interface/api/84489
 */
interface transferProps {
  strategyId: string;
  amount: number | string;
  transferType: number; //1.转入子账户  0.转出子账户
  coinName: string;
  bizType: number; // 1是保证金 2是利润
}
export const hoardPortfolioExtract = (params: transferProps) => {
  return commonInstance.post<BaseResponse<any>>("/portfolio/extract", params);
};
/*
 * 囤币宝最小追加保证金金额
 * https://yapi.sniper5.vip/project/44/interface/api/84471
 */
interface MinAddInvestAmountProps {
  strategyId: string;
}
export const hoardGetMinAddInvestAmount = (params: MinAddInvestAmountProps) => {
  return commonInstance.post<BaseResponse<any>>(
    "/portfolio/getMinAddInvestAmount",
    params
  );
};

/*
 * 囤币宝追加保证金
 * https://yapi.sniper5.vip/project/44/interface/api/84471
 */
export const hoardAddInvestAmount = (params: transferProps) => {
  return commonInstance.post<BaseResponse<any>>(
    "/portfolio/addInvestAmount",
    params
  );
};

/**
 * 子账户资产查询
 * https://yapi.sniper5.vip/project/44/interface/api/41566
 */
export const subAccountAssets = (params) => {
  return commonInstance.post("/subAccount/assets", params);
};

/**
 * 策略类型支持币对
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/52207
 * 1 现货网格 2 合约网格 3现货dca 4合约dca
 */
export const getStrategySupportSymbols = (params) => {
  return commonInstance.post("/config/supportSymbols", params);
};

/**
 * 现货双币获取投资额
 * @param params
 * @returns
 */
export const getGridInvestToken = (params): Promise<any> => {
  return commonInstance.post("/public/getGridInvestToken", params);
};

/**
 * 移动上停止价格查询
 * yapi: https://yapi.sniper5.vip/mock/44/v1/trigger/strategy/public/getMoveStopPriceLimit
 * @param params
 * @returns
 */
export const getMoveStopPriceLimit = (params): Promise<any> => {
  return commonInstance.post("/public/getMoveStopPriceLimit", params);
};

/*
 * 自动发布配置查询
 * yapi: https://yapi.sniper5.vip/project/53/interface/api/59010
 */
export const queryAutoUpDownConfig = () => {
  return platFormInstance.post("/user/queryAutoUpDownConfig");
};

/**
 * 获取币对支持的策略类型
 * @param params
 * @returns
 */
export const getStrategySecondTypeBySymbolIds = (params): Promise<any> => {
  return commonInstance.post(
    "/config/common/getStrategySecondTypeBySymbolIds",
    params
  );
};

/**
 * 获取交易买卖点
 * https://yapi.sniper5.vip/project/53/interface/api/71321
 * @param params
 * @returns
 */
export const queryHistoryTriggers = (params): Promise<any> => {
  return platFormInstance.post("/public/ai/queryHistoryTriggers", params);
};

/**
 * 策略后端精度获取
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/70651
 * 1 现货网格 2 合约网格 3现货dca 4合约dca
 */
export const getStrategyAccuracyConfig = (params) => {
  return commonInstance.post("/public/conf/strategyPrecision", params);
};

/**
 * 获取更新触发价需要的金额（网格）
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/78027
 */
export const getUpdateTriggerPriceAmountGrid = (params) => {
  return commonInstance.post("/grid/getUpdateTriggerPriceAmount", params);
};

/**
 * 获取更新触发价需要的金额（DCA）
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/78031
 */
export const getUpdateTriggerPriceAmountDCA = (params) => {
  return commonInstance.post("/dca/getUpdateTriggerPriceAmount", params);
};

/**
 * 更新触发价（网格）
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/78035
 */
export const updateTriggerPriceGrid = (params) => {
  return commonInstance.post("/grid/updateTriggerPrice", params);
};

/**
 * 更新触发价（DCA）
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/78043
 */
export const updateTriggerPriceDCA = (params) => {
  return commonInstance.post("/dca/updateTriggerPrice", params);
};

/**
 * 策略公告
 * yapi: https://yapi.sniper5.vip/project/44/interface/api/78043
 */
export const straetgyNotice = () => {
  return platFormInstance.post("/public/notify");
};

/**
 * 获取现货币价
 */
export const getTickerInfoBySymbolCodeDisplayName = (
  symbolCodeDisplayName: string
) => {
  return spotInstance.get<SPOT_TICKER_INFO_RES[]>(
    // 迁移过来的代码请求的接口 /public/getTickerInfoBySymbolCodeDisplayName
    "/public/getTickerInfo",
    {
      symbolId: symbolCodeDisplayName,
    }
  );
};
/**
 * 获取合约币价
 */
export const queryMarketTicker = (params: MARKET_TICKER_RES_REQUEST) => {
  return macpInstance.post<BaseResponse<MARKET_TICKER_RES>>(
    "/market/ticker",
    params
  );
};
